import React, { useContext, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import { treeActions } from "../../redux/slices/treeSlice";
import { Select, MenuItem, FormControl, InputLabel, Stack, } from '@mui/material';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";

function GroupByRecordName() {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector(state => state.treeData[parentScreen]);
  const dispatch = useDispatch();
  const [groupRecord, setGroupRecord] = useState('');
  const [groupField, setGroupField] = useState('');
  const [recordOptions, setRecordOptions] = useState([{name: '', fields: [], record: <MenuItem key={'NONE'} value='NONE'><span style={{height: 18}}></span></MenuItem>}]);
  const [fieldOptions, setFieldOptions] = useState([<MenuItem key={'NONE'} value='NONE'><span style={{height: 18}}></span></MenuItem>]);
  const [recordDisabled, setRecordDisabled] = useState(false);

  const getRecords = (rootNode) => {
    //set empty string as first item, for when a user wants no group-by record
    let records = [{
      name: '',
      fields: [],
      record: <MenuItem key={'NONE'} value='' fields={[]}><span style={{height: 18}}></span></MenuItem>
    }];

    if (!rootNode) return records;

    const getFieldsForRecord = (node) => {
      let empty = [<MenuItem key={'NONE'} value=''><span style={{height: 18}}></span></MenuItem>]
      let fields = node?.children?.filter(e => ["FIELD", "FIELD_LOOP"].includes(e.ICON_DISPLAY));
      if (!fields?.length) return empty;
      return fields.map(o => <MenuItem key={'gbf-'+(o.DESCRIPTION || o.MAPNAME ||  o.title)} value={o.MAPNAME || o.title}>{o.MAPNAME}</MenuItem>)
    }
    
    const loopRecord = (node) => {
      if (node.ICON_DISPLAY === "TEMPLATE_BODY_DOTS") node.children.forEach(o => loopRecord(o));
      let nodeIsParent = node.ICON_DISPLAY === "RECORD" || node.ICON_DISPLAY === "FIELD_GROUP" || node.ICON_DISPLAY === "RECORD_TOP" || node.ICON_DISPLAY === "REPEATING_FIELD_GROUP";
      if (nodeIsParent) {
        let nodeText = node.MAPNAME || node.TYPE || node.title;
        records.push({
          name: nodeText,
          fields: getFieldsForRecord(node),
          record: (
            <MenuItem key={`${nodeText}-${Math.random() * 10}`} value={nodeText}>
              {nodeText}
            </MenuItem>
          )
        });
        if (node?.children?.length) node.children.forEach(o => loopRecord(o));
      }
    }
    loopRecord(rootNode);
    return records;
  }

  const handleChange = (key, value) => {
    if (key === 'GROUP_RECORD_TYPE') setGroupField('');
    if (key === 'GROUP_RECORD_TYPE' && fieldOptions) {
      setGroupRecord(value);
    }
    if (key === 'GROUP_MAPNAME') setGroupField(value);
    dispatch(treeActions.setRightTreeTemplateHeaders({screen: parentScreen, key, value}));
  }

  useEffect(() => {
    const treeData = rightTree.tree[rightTree.currentTab].translatedData;
    if (treeData) {
      if (!treeData[0]) {
        setRecordOptions([{
          name: '',
          fields: [],
          record: <MenuItem key={'NONE'} value='' fields={[]}><span style={{height: 18}}></span></MenuItem>
        }]);
        setGroupRecord('')
        setRecordDisabled(true);
        return;
      }
      setRecordDisabled(false);
      setRecordOptions(getRecords(treeData[0]));
    }
  }, [rightTree.tree.templateHeader, rightTree.tree])

  useEffect(() => {
    const treeData = rightTree.tree[rightTree.currentTab].translatedData;
    if (treeData) {
      setGroupRecord('');
      setGroupField('');
      setRecordDisabled(false);
      setRecordOptions(getRecords(treeData[0]));
    }
  }, [rightTree.currentTab])

  useEffect(() => {
    if (!rightTree.tree[rightTree.currentTab].translatedData[0]) { 
      setRecordDisabled(true);
      setFieldOptions([<MenuItem key={'NONE'} value=''><span style={{height: 18}}></span></MenuItem>]);
      return;
    }
    setRecordDisabled(false);
    const header = rightTree.tree.templateHeader;
    if (
      header.GROUP_RECORD_TYPE && 
      recordOptions && 
      recordOptions.filter(o => o.record.props.value === header.GROUP_RECORD_TYPE).length
    ) setGroupRecord(header.GROUP_RECORD_TYPE);
    else setGroupRecord('');
  }, [recordOptions])

  useEffect(() => {
    setFieldOptions(recordOptions.filter(o => o.name === groupRecord)[0]?.fields);
  }, [groupRecord,])

  useEffect(() => {
    const header = rightTree.tree.templateHeader;
    if (
      header.GROUP_MAPNAME && 
      fieldOptions && 
      fieldOptions.filter(o => o.props.value === header.GROUP_MAPNAME).length
    ) setGroupField(header.GROUP_MAPNAME);
    else setGroupField('');
    
    if (fieldOptions && fieldOptions.length === 1 && fieldOptions[0].props.value === '') {
      setGroupField(fieldOptions[0].props.value);
      if (fieldOptions[0].props.value) handleChange('GROUP_MAPNAME', fieldOptions[0].props.value);
    }
  }, [fieldOptions, rightTree.tree.templateHeader])

  return (
    <>
      <>
        <FormControl size="small" variant="outlined">
          <InputLabel id="gbrDropdownLabel">{t('LBL_GROUP_BY_REC_NAME')}</InputLabel>
          <Select
            className="width-100"
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 250
                }
              }
            }}
            labelId="gbrDropdownLabel"
            id="gbrDropdown"
            value={groupRecord}
            onChange={(e) => handleChange('GROUP_RECORD_TYPE', e.target.value)}
            label={t('LBL_GROUP_BY_REC_NAME')}
          >
            {recordOptions.map(o => o.record)}
          </Select>
        </FormControl>
        <FormControl size="small" variant="outlined">
          <InputLabel id="gbfDropdownLabel">{t('LBL_GROUP_BY_FLD_NAME')}</InputLabel>
          <Select
            className="width-100"
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 250
                }
              }
            }}
            labelId="gbfDropdownLabel"
            id="gbfDropdown"
            value={groupField}
            onChange={(e) => handleChange('GROUP_MAPNAME', e.target.value)}
            label={t('LBL_GROUP_BY_FLD_NAME')}
          >
            {fieldOptions}
          </Select>
        </FormControl>
      </>
    </>
  )
}

export default GroupByRecordName